import React from 'react';

const Skills = () => {
    const skills = [
        {
            title: "Frontend",
            languages: [
                "React.js",
                "React Native",
                "Next.js",
                "JavaScript",
                "TypeScript",
                "JSP",
                "HTML",
                "CSS",
                "Tailwind",
                "GSAP",
            ],
        },
        {
            title: "Backend",
            languages: [
                "Java",
                "Node.js",
                "Express.js",
                "Python",
                "FastAPI",
            ],
        },
        {
            title: "Testing & QA",
            languages: [
                "Postman",
                "Selenium (Basic)",
                "Appium (Basic)",
                "ADB Commands"
            ],
        },
        {
            title: "Tools & Platforms",
            languages: [
                "Git",
                "GitHub",
                "Jira (Agile)",
                "VS Code",
                "IntelliJ IDEA",
                "MongoDB",
                "Supabase",
                "SQLite",
                "MS Excel",
                "MS Word",
            ],
        },
        {
            title: "API & Development",
            languages: [
                "REST API Integration"
            ],
        },
    ];

    return (
        <div className="px-5 max-w-[1560px] mx-auto pt-20 py-10">
            {/* title */}
            <div className="mb-12 text-[32px] font-medium text-white">
                <span className='text-[#C778DD]'>⚙️</span> Skills
            </div>

            {/* cards */}
            <div className="flex justify-around gap-4 flex-wrap">
                {skills.map(({ title, languages }) => (
                    <div
                        key={title}
                        className="w-[90%] sm:w-[45%] md:w-[24%] lg:w-[18%] border border-[#ABB2BF]"
                    >
                        <div className="text-white p-2">
                            <h2 className="font-semibold">{title}</h2>
                        </div>

                        <div className="flex gap-2 border-t border-[#ABB2BF] flex-wrap p-2 text-[#ABB2BF]">
                            {languages.map((item, idx) => (
                                <span key={idx}>{item}</span>
                            ))}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Skills;
